import * as m from 'mithril';

import WayPointFilterList from "./WayPointFilterList";
import { NavBar } from '../../components/NavBar';
import { MessageProvider } from '../../context/AppMessages';
import AppContext from '../../context/AppContext';
import buildLanguageChangeActions from '../common/LanguageNavActions';
import { getIntlStringValue } from '../../helpers/StringHelpers';
import CustomSvgIcon from '../../components/CustomSvgIcon';
import { MoneyDTO, PickUpOrderLineItemDTO, PickUpServiceOptionDTO, WayPointOptionDTO } from '../../apiclient/ApiDtos';
import { formatMoney } from '../../helpers/MoneyFormatter';
import SpinnerBox from '../../components/SpinnerBox';
import { Option, RadioGroup } from '../../components/BootstrapForm';

interface Attrs {
    appContext: AppContext,
    messageProvider: MessageProvider,
    title: string,
    maxSeatCount: number,
    totalNumberOfTravellers: number,
    currentEditingPickupLineItem: PickUpOrderLineItemDTO | null,
    pickupOptions: PickUpServiceOptionDTO[],
    onPickupOrderLineItemAdded: (pickupLineItem: PickUpOrderLineItemDTO) => void,
    onPickupOrderLineItemUpdated: (newItem: PickUpOrderLineItemDTO, oldItem: PickUpOrderLineItemDTO) => void,
    onBack: () => void
}

export default function PickupInformationFormPage(): m.Component<Attrs> {

    let selectedOption: PickUpServiceOptionDTO | null = null;
    let selectedNumberOfSeats: number | null = null;
    let address = "";

    let selectingOption = true;
    let showingAddressWarning = false;
    let showingSelectedNumberOfSeatsWarning = false;
    return {
        oninit(vnode) {
            console.log("Pickup form - oninit - editingItem:", vnode.attrs.currentEditingPickupLineItem);

            if (vnode.attrs.currentEditingPickupLineItem) {
                selectedOption = vnode.attrs.currentEditingPickupLineItem.option;
                selectedNumberOfSeats = vnode.attrs.currentEditingPickupLineItem.numberOfSeats;
                address = vnode.attrs.currentEditingPickupLineItem.address;
            } else {
                //selectedNumberOfSeats = vnode.attrs.maxSeatCount;
                if (vnode.attrs.maxSeatCount == 1) {
                    selectedNumberOfSeats = 1;
                }
            }
            selectingOption = selectedOption == null;
        },
        view(vnode) {
            let { messageProvider } = vnode.attrs;
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);
            let currentLang = messageProvider.getCurrentLang();

            let passengerCountOptions: Option[] = [];
            for (let i = 1; i <= vnode.attrs.maxSeatCount; i++) {
                passengerCountOptions.push({
                    value: String(i),
                    label: String(i),
                    description: (i == vnode.attrs.totalNumberOfTravellers && i != 1) ?
                        "(" + messageProvider.get("way_point_selection.all_travellers") + ")" : ""
                })
            }

            return [
                m('div', { class: 'app-layout bg' }, [
                    m(NavBar, {
                        title: vnode.attrs.title,
                        canBackPress: true,
                        onBackPressed: () => {
                            if (vnode.attrs.currentEditingPickupLineItem == null && selectingOption) {
                                vnode.attrs.onBack();
                            } else if (vnode.attrs.currentEditingPickupLineItem != null && !selectingOption) {
                                vnode.attrs.onBack();
                            } else {
                                selectingOption = !selectingOption;
                            }
                        },
                        actionItems: langChangeActionItems
                    }),
                    m("div.app-area-main",

                        selectingOption ?
                            m(WayPointFilterList, {
                                mode: "PICKUP",
                                messageProvider: vnode.attrs.messageProvider,
                                wayPointOptions: vnode.attrs.pickupOptions,
                                onWayPointSelected: (selectedWayPoint: PickUpServiceOptionDTO) => {
                                    selectedOption = selectedWayPoint;
                                    if (selectedWayPoint.mode == 'FIXED_POINT') {
                                        address = ""
                                    }
                                    selectingOption = false;
                                }
                            })
                            :

                            m("div.m-3",

                                m("div.d-flex justify-content-between",
                                    m("div.text-secondary mb-2",
                                        selectedOption?.mode == 'FIXED_POINT' ? messageProvider.get("common.gathering_point") : messageProvider.get("common.home_address_pickup_location"),
                                    ),
                                    m("div.small font-weight-bold text-primary text-right text-end", {
                                        style: "min-width: 90px;",
                                        onclick: () => {
                                            selectingOption = true;
                                        }
                                    },
                                        messageProvider.get("to_reselect"),
                                        m(CustomSvgIcon, {
                                            iconType: "caret_arrow_right",
                                            themeCssClass: "svg-primary svg-small"
                                        })

                                    )
                                ),

                                m("div.d-flex_ justify-content-between_ p-3 bg-white rounded shadow-sm", {
                                    onclick: () => {
                                        selectingOption = true;
                                    }
                                },
                                    m("div",
                                        m("div.font-weight-bold",
                                            selectedOption != null ? getIntlStringValue(selectedOption.name, currentLang)
                                                : ""
                                        ),
                                        (selectedOption != null) ?
                                            m("div.mt-1 small text-muted",
                                                (selectedOption.pricingMode == 'PER_STOP') ? null : [vnode.attrs.messageProvider.get("way_point_selection.one_person"), " ▹ "],
                                                m("span.text-success", formatMoney(selectedOption.unitFee))
                                            ) : ""
                                    ),
                                    /* m("div",
                                        m(CustomSvgIcon, {
                                            iconType: "caret_arrow_down",
                                            themeCssClass: "svg-info svg-small"
                                        })
                                    ) */
                                ),


                                selectedOption != null && selectedOption.mode == 'DOORSTEP' &&
                                m("div",
                                    m("div.mt-4 text-secondary",
                                        messageProvider.get("way_point_selection.pickup_location_details"),
                                        m("sup.ml-1 error", "*")
                                    ),
                                    m("textarea.form-control mt-1", {
                                        value: address,
                                        rows: 3,
                                        class: showingAddressWarning ? "border-danger" : "",
                                        oninput: (e: InputEvent) => {
                                            address = (e.target as HTMLTextAreaElement).value;
                                            showingAddressWarning = false;
                                        }
                                    })
                                ),

                                m("div.mt-4", {
                                    class: vnode.attrs.totalNumberOfTravellers == 1 ? "d-none" : ""
                                },
                                    /*m(SpinnerBox, {
                                        singularLabel: messageProvider.get("way_point_selection.no_of_traveller_unit"),
                                        pluralLabel: messageProvider.get("way_point_selection.no_of_travellers_unit"),
                                        initialValue: selectedNumberOfSeats,
                                        minCount: 1,
                                        maxCount: vnode.attrs.maxSeatCount,
                                        onCountChange: function (newValue) {
                                            selectedNumberOfSeats = newValue;
                                        }
                                    }),*/

                                    m("div", {
                                        //class: showingSelectedNumberOfSeatsWarning ? "border border-danger" : "",
                                        style: showingSelectedNumberOfSeatsWarning ?
                                            "outline: 1px solid var(--danger); border-radius:5px; outline-offset: 5px" : ""
                                    },
                                        m(RadioGroup, {
                                            label: selectedOption?.mode == "FIXED_POINT" ? messageProvider.get("way_point_selection.number_of_travellers_from_fixpoint") : messageProvider.get("way_point_selection.number_of_travellers_from_pickup_location"),
                                            name: "numPassengers",
                                            lang: messageProvider.getCurrentLang(),
                                            options: passengerCountOptions,
                                            required: true,
                                            layout: 'vertical',
                                            useBackground: true,
                                            initialValue: (selectedNumberOfSeats != null) ? String(selectedNumberOfSeats) : null,
                                            //getCustomValidityMessage: (vs) => "Passengers required", //getIntlString(messageProvider, "validity.required_selection"),
                                            onValueChange: (newValue: string) => {
                                                selectedNumberOfSeats = parseInt(newValue);
                                                showingSelectedNumberOfSeatsWarning = false;

                                            },
                                            validityReportingAllowed: true,
                                            onInvalid: vs => {

                                            }
                                        })
                                    ),
                                ),

                                selectedOption?.mode == 'FIXED_POINT' &&
                                m("div.mt-4 ",
                                    m("div.rounded mt-2 p-3 small text-secondary",{
                                        style: "background-color: rgb(221, 226, 231) !important; color: #305C73 !important;"
                                    },
                                        m("div.text-info mb-3",
                                            messageProvider.get("common.gathering_point_description")
                                        ),

                                        m("div",{
                                            style: "line-height: 2rem;"
                                        },
                                            selectedOption.description ?
                                                messageProvider.getCurrentLang() == "en" ?
                                                    selectedOption.description.en ? selectedOption.description.en : m("span.text-muted", "-")
                                                    :
                                                    selectedOption.description.my ? selectedOption.description.my : m("span.text-muted", "-")
                                                :
                                                m("span.text-muted", "-")
                                        )

                                    )
                                )

                                /*  m("div.mt-4",
                                     m("div",
                                         m(HybridLocationPicker)
                                     )
                                 ) */
                            )
                    ),

                    !selectingOption &&
                    m("div.app-area-footer",
                        m("div.p-2",
                            m("button.form-control btn btn-primary", {
                                //disabled: (currentEditingLineItem && currentEditingLineItem.address.trim() != "") ? null : "disabled",
                                onclick: () => {
                                    if (selectedOption != null) {
                                        if (selectedOption.mode == 'DOORSTEP' && address == "" || address == null) {
                                            showingAddressWarning = true;
                                            return;
                                        }

                                        if (!selectedNumberOfSeats) {
                                            showingSelectedNumberOfSeatsWarning = true;
                                            return;
                                        }


                                        let totalAmount: MoneyDTO = {
                                            amount: selectedNumberOfSeats * selectedOption.unitFee.amount,
                                            currency: selectedOption.unitFee.currency
                                        };
                                        let lineItem = {
                                            option: selectedOption,
                                            totalFee: totalAmount,
                                            numberOfSeats: selectedNumberOfSeats,
                                            address: address
                                        };

                                        if (vnode.attrs.currentEditingPickupLineItem) {
                                            vnode.attrs.onPickupOrderLineItemUpdated(lineItem, vnode.attrs.currentEditingPickupLineItem);
                                        } else {
                                            vnode.attrs.onPickupOrderLineItemAdded(lineItem);
                                        }
                                    }
                                }
                            }, "Done")
                        )
                    )
                ])

            ];
        }
    }
}